module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newContainerCourse"
  }, [_c('message-system', {
    attrs: {
      "size": "small"
    }
  }), _vm._v(" "), (!_vm.course) ? _c('div', {}, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v(" Cargando...\n  ")]) : _c('div', [_c('header', [_c('div', {
    staticClass: "supertext"
  }, [_c('h2', [_vm._v(_vm._s(_vm.course.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "contentCourse"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column has-text-right"
  }, [_c('button', {
    staticClass: "button is-info is-large is-pulled-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.go()
      }
    }
  }, [_vm._v("\n            Inscribirme\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.course.description)
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column has-text-centered"
  }, [_c('new-price', {
    attrs: {
      "data": _vm.course.price
    }
  })], 1), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column yellow"
  }, [_c('ul', {
    staticClass: "modules"
  }, _vm._l((_vm.course.modules), function(module) {
    return _c('li', [_vm._v("\n              " + _vm._s(module.name) + "\n              "), _c('ul', _vm._l((module.classes), function(room) {
      return _c('li', [_vm._v(_vm._s(room))])
    }), 0)])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column has-text-right"
  }, [_c('button', {
    staticClass: "button is-info is-large is-pulled-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.go()
      }
    }
  }, [_vm._v("\n            Inscribirme\n          ")])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column has-text-centered subtitleZone green"
  }, [_c('h2', [_vm._v("Inversión")])]), _vm._v(" "), _c('div', {
    staticClass: "column has-text-centered subtitleZone yellow"
  }, [_c('h2', [_vm._v("Formas de Pago")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "paymentInfo"
  }, [_vm._v("\n            Nuestras formas de pago son muchas:\n            "), _c('ul', [_c('li', [_c('b', [_vm._v(" - PayPal")])]), _vm._v(" "), _c('li', [_c('b', [_vm._v(" - Tarjeta de Crédito o Débito(con la seguridad de PayPal)")])]), _vm._v(" "), _c('li', [_c('b', [_vm._v(" - Western Union")])]), _vm._v(" "), _c('li', [_c('b', [_vm._v(" - Transferencia a Banco Locales en Perú y Guatemala")])])])]), _vm._v(" "), _c('div', {
    staticClass: "paymentInfoLogos"
  }, [_c('img', {
    attrs: {
      "src": "static/logo-paypal.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "static/logo-wu.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "static/logo-bcp.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "static/logo-big.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column has-text-centered subtitleZone blue"
  }, [_c('h2', [_vm._v("Profesores")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column has-text-centered subtitleZone blue"
  }, [_c('h2', [_vm._v("Contenido")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f377f10","hasScoped":true}!./src/pages/course/template.html
// module id = 412
// module chunks = 1